/**
 * Open/close rules for the user portal navigation bar.
 *
 * The portal nav is an in-DOM template driven by the root Vue instance rather
 * than a component, so this lives here as a plain options object: it keeps
 * app.ts thin and lets the rules be unit tested without mounting the app.
 */
export const portalMenuOptions = {
  data() {
    return {
      profileMenuIsOpen: false,
      kbMenuIsOpen: false,
      navbarMenuIsOpen: false,
    }
  },
  mounted() {
    document.addEventListener('click', this.closeMenusOnOutsideClick)
    document.addEventListener('keydown', this.closeMenusOnEscape)
  },
  unmounted() {
    document.removeEventListener('click', this.closeMenusOnOutsideClick)
    document.removeEventListener('keydown', this.closeMenusOnEscape)
  },
  methods: {
    closeMenus(this: PortalMenus) {
      this.profileMenuIsOpen = false
      this.kbMenuIsOpen = false
      this.navbarMenuIsOpen = false
    },
    toggleProfileMenu(this: PortalMenus) {
      const opening = !this.profileMenuIsOpen
      this.closeMenus()
      this.profileMenuIsOpen = opening
    },
    /**
     * Leaves the mobile menu alone: on small screens the knowledge base
     * dropdown is nested inside it, so closing it here would collapse the very
     * menu the button lives in.
     */
    toggleKbMenu(this: PortalMenus) {
      const opening = !this.kbMenuIsOpen
      this.profileMenuIsOpen = false
      this.kbMenuIsOpen = opening
    },
    toggleNavbarMenu(this: PortalMenus) {
      const opening = !this.navbarMenuIsOpen
      this.closeMenus()
      this.navbarMenuIsOpen = opening
    },
    /**
     * Anything marked `data-menu` handles its own clicks; a click anywhere else
     * dismisses every open menu.
     */
    closeMenusOnOutsideClick(this: PortalMenus, event: MouseEvent) {
      const target = event.target
      if (target instanceof Element && target.closest('[data-menu]')) {
        return
      }
      this.closeMenus()
    },
    closeMenusOnEscape(this: PortalMenus, event: KeyboardEvent) {
      if (event.key === 'Escape') {
        this.closeMenus()
      }
    },
  },
}

type PortalMenus = {
  profileMenuIsOpen: boolean
  kbMenuIsOpen: boolean
  navbarMenuIsOpen: boolean
  closeMenus: () => void
}
